var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close"},[_c('div',{on:{"click":function($event){return _vm.close()}}},[_vm._v("✖")]),_vm._v(" "),(_vm.askclose)?_c('d-msg',{attrs:{"title":"Close","text":"Close current work?","yesno":""},on:{"close":function($event){return _vm.confirmclose($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae8b47f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/_eng/globals/dclose.vue
// module id = 1606
// module chunks = 147